import axios from "axios";
import { clearAuth, getToken } from "../utils/storage";

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "",
  timeout: 10000
});

request.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

request.interceptors.response.use(
  (response) => {
    const body = response.data || {};
    if (typeof body.success === "boolean") {
      if (body.success) {
        return body.data;
      }
      return Promise.reject(new Error(body.message || "请求失败"));
    }
    return body;
  },
  (error) => {
    const status = error && error.response ? error.response.status : null;
    if (status === 401) {
      clearAuth();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    const message =
      (error &&
        error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      "网络异常，请稍后重试";
    return Promise.reject(new Error(message));
  }
);

export default request;
